import { render, staticRenderFns } from "./需求项目商品详细_默认版本.vue?vue&type=template&id=e3142e6e&scoped=true"
import script from "./需求项目商品详细_默认版本.vue?vue&type=script&lang=js"
export * from "./需求项目商品详细_默认版本.vue?vue&type=script&lang=js"
import style0 from "./需求项目商品详细_默认版本.vue?vue&type=style&index=0&id=e3142e6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3142e6e",
  null
  
)

export default component.exports